import BerichtAntragscontrollingAsideFilters from "./BerichtAntragscontrollingAsideFilters/BerichtAntragscontrollingAsideFilters.vue";

export default {
  BerichtAntragscontrollingAsideFilters,
};
